import { Provider, inject } from '@angular/core';
import { AppConfigService } from '@app/config/config.service';
import { DatadogService, buildDatadogConfig, DATADOG_CONFIG_TOKEN } from '@cudirect/shared-ui-library';

export const provideDatadog = (): Provider[] => [
  {
    provide: DATADOG_CONFIG_TOKEN,
    useFactory: (appConfig: AppConfigService) => {
      const config = appConfig.getData();
      return buildDatadogConfig(config?.dataDog);
    },
    deps: [AppConfigService]
  },
  {
    provide: DatadogService,
    useFactory: () => {
      const config = inject(DATADOG_CONFIG_TOKEN);
      const datadog = new DatadogService();
      datadog.init(buildDatadogConfig(config));
      return datadog;
    },
    deps: [DATADOG_CONFIG_TOKEN]
  }
];
